import { FETCH_INSTITUTION_CONTACTS_DATA } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(FETCH_INSTITUTION_CONTACTS_DATA);
export default reducer;
